import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MarketmanagerSharedModule } from '../../shared';
import {
    ContractdateService,
    ContractdatePopupService,
    ContractdateComponent,
    ContractdateDetailComponent,
    ContractdateDialogComponent,
    ContractdatePopupComponent,
    ContractdateDeletePopupComponent,
    ContractdateDeleteDialogComponent,
    contractdateRoute,
    contractdatePopupRoute,
} from './';

const ENTITY_STATES = [
    ...contractdateRoute,
    ...contractdatePopupRoute,
];

@NgModule({
    imports: [
        MarketmanagerSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        ContractdateComponent,
        ContractdateDetailComponent,
        ContractdateDialogComponent,
        ContractdateDeleteDialogComponent,
        ContractdatePopupComponent,
        ContractdateDeletePopupComponent,
    ],
    entryComponents: [
        ContractdateComponent,
        ContractdateDialogComponent,
        ContractdatePopupComponent,
        ContractdateDeleteDialogComponent,
        ContractdateDeletePopupComponent,
    ],
    providers: [
        ContractdateService,
        ContractdatePopupService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MarketmanagerContractdateModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contractdate/contractdate.module.ts